const beautyBasicPlan = {
  items: [
    {
      componentName: 'groupCard',
      pageBreak: true,
      itemId: 'front',
      heading: '表紙',
      items: [
        {
          componentName: 'frontPageCard',
          itemId: 'front-title-author',
          heading: 'タイトル・作成者情報',
          data: {
            title: '事業計画書',
            subTitle: 'トータルビューティーサロン MEGURO',
            url: '',
            companyFormat: 'freelance',
            companyName: '',
            authorName: '鈴木 海',
            createDate: new Date()
          }
        }
      ]
    },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'motivation',
      heading: '創業の動機',
      items: [
        {
          componentName: 'textCard',
          itemId: 'motivation-inner',
          heading: '',
          data: {
            text: 'エステシャンとして、施術や店舗運営を3年間経験。多くのお客様から指名を頂いた。働く女性や子育て世代のお母さんに高品質なトータルビューティーサービスを提供すべく、独立を決意。エステサロンの元同僚ほか計3名をパートタイムとして雇用し、広告代理店時代のマーケティングスキルと人脈を活かして目黒エリアで開業予定である。',
            minRaws: 5
          }
        }
      ]
    },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'company-profile',
      heading: '会社概要',
      items: [
        {
          componentName: 'companyProfileCard',
          itemId: 'company-profile-inner',
          heading: '',
          data: {
            companyName: '',
            establishedDate: {
              year: '',
              month: ''
            },
            ceo: '',
            capital: '',
            address: {
              postalCode: '',
              postalDetail: ''
            },
            tel: '',
            url: '',
            businessContentsSimple: ''
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'president-info',
      heading: '経営者略歴等',
      items: [
        {
          componentName: 'nameAddressCard',
          itemId: 'president-info-name-address',
          heading: '氏名・現住所',
          data: {
            address: {
              postalCode: '〒105-0000',
              postalDetail: '東京都港区 ○○町1-2-3'
            },
            dateOfBirth: {
              year: 1989,
              month: 12,
              day: 10
            },
            name: '鈴木 海',
            gender: {
              kind: 'female',
              customText: ''
            }
          }
        },
        {
          componentName: 'jobHistoryCard',
          itemId: 'president-info-job-history',
          heading: '経歴',
          data: {
            histories: [
              {
                date: {
                  year: 2012,
                  month: 3
                },
                termDate: {
                  year: '',
                  month: ''
                },
                desc: '○○○大学政治経済学部卒業'
              },
              {
                date: {
                  year: 2012,
                  month: 4
                },
                termDate: {
                  year: '',
                  month: ''
                },
                desc: '広告代理店○○○に3年勤務し、美容業界のマーケティングプロモーションを数多く実施'
              },
              {
                date: {
                  year: 2015,
                  month: 7
                },
                termDate: {
                  year: '',
                  month: ''
                },
                desc: '○○○サロン表参道店にエステシャンとして3年勤務し、多くのお客様を施術。\nエステスクールの講師を担当(パートタイム)'
              },
              {
                date: {
                  year: 2018,
                  month: 9
                },
                termDate: {
                  year: '',
                  month: ''
                },
                desc: '退職・開業準備'
              }
            ]
          }
        },
        {
          componentName: 'dateCard',
          itemId: 'president-info-opening-date',
          heading: '開業予定日',
          data: {
            date: {
              year: 2019,
              month: 1,
              day: 2
            }
          }
        },
        {
          componentName: 'textCard',
          itemId: 'president-info-opening-place',
          heading: '開業予定地',
          data: {
            text: '目黒駅周辺のマンション物件2LDK。施術部屋:3部屋(リビングを含め、パーテーション等で区切って部屋を分ける)。\n茶色を基調とした家具で統一し、落ち着いた空間をつくる。リビングルームにはカラフルなキッズルームを完備する。'
          }
        },
        {
          componentName: 'manageExperienceCard',
          itemId: 'president-info-manage-experience',
          heading: '経営経験',
          data: {
            experienceStatus: 'inexperience',
            businessContents: '',
            stopDate: {
              year: '',
              month: ''
            }
          }
        },
        {
          componentName: 'licenceCard',
          itemId: 'president-info-licence',
          heading: '取得資格',
          data: {
            licencies: [
              { name: '○○○認定エステティシャン取得' }
            ]
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'business-contents',
      heading: '事業内容',
      items: [
        {
          componentName: 'textCard',
          itemId: 'business-contents-purpose',
          heading: '業種業態',
          data: {
            text: 'エステサロン'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-open-day-hour',
          heading: '営業日・営業時間',
          data: {
            text: '営業日 : 11:00 - 21:00\n月曜定休日'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-major-article',
          heading: '主要商品',
          data: {
            text: '小顔フェイシャル 12000円/60分（回数券５回 ：57000円）\nスリムボディマッサージ 14000円/60分（回数券５回 ：65000円）\nリラックストリートメント 8000円/40分（回数券５回 ：38000円）'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-characteristic',
          heading: '特徴',
          data: {
            text: '乳幼児が遊べるキッズルームを施設内に完備し、子連れの方でも気軽に施術を受けられるようにする。店舗は利便性の高い駅前のマンションの1室を利用。'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-target',
          heading: '客層/販売先',
          data: {
            text: '昼：子連れの女性住民など\n夜：女性オフィスワーカーなど'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-acquisition-strategy',
          heading: '集客戦略',
          data: {
            text: '当初は口コミを中心に集客する。前店の40%の固定客が新店を利用予定。マス広告は行わず、SNS配信やエステスクールでのチラシ配布を実施。'
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'market-environment',
      heading: '市場環境',
      items: [
        {
          componentName: 'textCard',
          itemId: 'market-environment-customer',
          heading: '顧客状況',
          data: {
            text: '2017年の市場規模は3,579億円、前年度比100.2％で昨年に続き横ばい傾向が続く。メンズやダイエットなどに、特化した専門店が増加傾向にある。今後のエステサロンの成功要因は、「品質」「ホスピタリティ」「空間」「スタッフ」であると考える。\n青山・表参道など都内ではサロンエステ開業は増加している。施術の品質がよく、かつ長期的なファンとの関係性をつくれる店長やスタッフがいる店舗しか生き残れなくなってきた。'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'market-environment-area-characteristics',
          heading: 'エリア特性',
          data: {
            text: '駅前再開発により利便性が増し、子育て世代に人気のエリア。\n高級住宅街からも近く、富裕層がアクセスするのに便利なエリア。'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'market-environment-competitive-advantage',
          heading: '競合優位性',
          data: {
            text: '目黒駅前周辺：十数店舗\n価格帯：8000円/60分〜\n\nふらっと立ち寄れるをコンセプトに、キッズルームやハーブディーなど充実させる。広告代理店時代の人脈を活かし、海外の最新美容マシンを導入し、他でない施術のメニューも揃えていく。'
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'operation',
      heading: '運営',
      items: [
        {
          componentName: 'stakeholdersCard',
          itemId: 'operation-business-partner',
          heading: '取引先',
          data: {
            stakeholders: [
              {
                name: '個人顧客',
                address: '',
                shareRate: 100,
                salesOnCreditRate: 70,
                closingAndPayment: '末日 即金/カード'
              }
            ]
          }
        },
        {
          componentName: 'stakeholdersCard',
          itemId: 'operation-supplier',
          heading: '仕入先',
          data: {
            stakeholders: [
              {
                name: '○○○リース',
                address: '東京都○○○区○○○町1-2-3',
                shareRate: 40,
                salesOnCreditRate: 0,
                closingAndPayment: '末日　翌月末支払'
              },
              {
                name: '○○○プロダクツ',
                address: '東京都○○○区○○○町3-2-3',
                shareRate: 60,
                salesOnCreditRate: 0,
                closingAndPayment: '末日　翌月末支払'
              }
            ]
          }
        },
        {
          componentName: 'stakeholdersCard',
          itemId: 'operation-subcontractor',
          heading: '外注先',
          data: {
            stakeholders: [
              {
                name: 'なし',
                address: '-',
                shareRate: '',
                salesOnCreditRate: '',
                closingAndPayment: ''
              }
            ]
          }
        },
        {
          //TODO:change card
          componentName: 'manpowerPlanningCard',
          itemId: 'operation-manpower-planning',
          heading: '人員計画',
          data: {
            positions: [
              {
                kind: '常勤役員',
                number: 0,
                detail: ''
              },
              {
                kind: '従業員',
                number: 3,
                detail: '正社員 0人\nパート従業員 3人'
              }
            ],
            salaryPayment: '末日〆、翌25日支払 (ボーナスの支給日：12月)'
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'borrowing',
      heading: 'お借入の状況',
      items: [
        {
          //TODO:change card
          componentName: 'borrowerCard',
          itemId: 'borrowing-borrower',
          heading: '借入先',
          data: {
            borrowers: [
              {
                name: 'なし',
                howUse: '-',
                amount: '-',
                repaymentAtYear: '-'
              }
            ]
          }
        }
      ]
    },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'free',
      heading: '自由記述',
      items: [
        {
          componentName: 'textCard',
          itemId: '',
          heading: '',
          data: {
            text: '前職時代からスクールでの講義を受け持っており、開業後も継続して講師を担当する。後進のエステシャンの育成にも力をいれていきたい。'
          }
        }
      ]
    },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'other-document',
      heading: '別紙資料',
      items: [
        {
          componentName: 'textCard',
          itemId: '',
          heading: '',
          data: {
            text: '・損益計算書\n・資金調達計画\n・投資計画',
            minRaws: 3
          }
        }
      ]
    }
  ]
}

export default beautyBasicPlan
